<template>
    <modal width="500px">
        <div slot="body">
            <div class="title" style="font-size:1.2em; white-space: normal; text-align: center">
                {{ $t('lockdowns') }}
            </div>
            <table class="custom-table">
                <thead>
                <th>{{ $t('date') }}</th>
                <th style="width:3.5em">{{ $t('delete') }}</th>
                </thead>
                <tbody v-if="objects.length > 0">
                <tr v-for="(obj, index) in objects" :key="index" >
                    <td>
                    {{ obj.date | moment('DD/MM/YYYY') }}
                    </td>
                    <td style="padding:0; font-size:1.5em; color: #DD3355; cursor: pointer">
                    <i class="fa fa-times" @click="deleteDate(obj)"/>
                    </td>
                </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="2">
                            No data
                        </td>
                    </tr>
                </tbody>
          </table>
          <div id="pages">
            <div class="move-page" @click="page > 1 ? loadRestrictedDates(page-1) : ''">
              «{{ $t('prev') }}.
            </div>
            <div v-for="pageShown in pagesShown" :key="pageShown" :class="page===pageShown? 'selected-page': 'page'" @click="loadRestrictedDates(pageShown)">
              {{ pageShown }}
            </div>
            <div class="move-page" @click="page < count/pageSize ? loadRestrictedDates(page+1) : ''">
              {{ $t('next') }}.»
            </div>
          </div>
          <div style="margin:1em 0">
              <label>
                {{ $t('new_lockdown') }}
              </label>
              <input type="date" v-model="lockdown" />
          </div>
            <div class="buttons">
                <button class="btn-blue" @click="saveDate()">
                    {{ $t('create') }}
                </button>
                <button class="btn-black" @click="$emit('close')">
                    {{ $t('close') }}
                </button>
            </div>
        </div>
    </modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Modal from './../components/Modal'
export default {
  name: '',
  components: {Modal},
  props: [''],
  created () {
  },
  computed: {
    ...mapState({
      count: state => state.lines.lockdownCount,
      page: state => state.lines.lockdownPage
    }),
    pagesShown: {
      get: function () {
        var pages = [this.page]
        for (let index = 1; index <= 2; index++) {
          if (this.page - index > 0) {
            pages.push(this.page - index)
          }
          if (this.page + index <= Math.ceil(this.count / this.pageSize)) {
            pages.push(this.page + index)
          }
        }
        return pages.sort(function (a, b) { return a - b })
      }
    }
  },
  mounted () {
    this.loadRestrictedDates()
  },
  data () {
    return {
      objects: [],
      lockdown: {},
      pageSize: 10
    }
  },
  methods: {
    ...mapActions({
      createRestrictedDates: 'restrictedDates/save',
      getRestrictedDates: 'restrictedDates/list',
      deleteRestrictedDate: 'restrictedDates/delete'
    }),
    loadRestrictedDates (page) {
      this.getRestrictedDates({page: page || 1, page_size: this.pageSize}).then(response => { this.objects = response })
    },
    saveDate () {
      this.createRestrictedDates({date: this.lockdown}).then(() => {
        this.lockdown = ''
        this.loadRestrictedDates()
      })
    },
    deleteDate (ld) {
      this.deleteRestrictedDate(ld.id).then(() => {
        this.$notify({ group: 'global', type: 'success', duration: 4000, title: 'Success', text: this.$t('deleted') })
        this.loadRestrictedDates()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .errors{
        display: flex;
        flex-direction: column;
        .error {
            background: #C9D713;
            display: inline-block;
            font-size: 1.1em;
            text-align: center;
            margin: .2em 2.5em;
            padding: .2em 0;
            border-radius: .5em;
        }
    }
    .buttons{
        display: flex;
        margin-top: .5em;
        justify-content: center;
        button{
            margin: 0 1em;
        }
    }
    .custom-table{
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Lockdowns.vue